import React from "react";
import "./CreativeDesignSection1.css";
import designImage from "../../../assets/CyprioJob-Mockup.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CreativeDesignSection1 = () => {
  const { lang } = useParams();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const { t } = useTranslation("global");

  return (
    <section className="creative-designs" aria-label="Creative Design Services">
      {/* Left Side - Text Content */}
      <div className="design-text">
        <p className="welcome-text">
          {t("creativeDesignSection1.welcomeText")}
        </p>
        <h1 className="main-heading">
          {t("creativeDesignSection1.heading1")}{" "}
          <span className="highlight-creative">
            {t("creativeDesignSection1.headingHighlight")}
          </span>{" "}
          {t("creativeDesignSection1.heading2")}
        </h1>

        <p className="description-section1">
          {t("creativeDesignSection1.description")}
        </p>
        <Link
          to={`/${lang}/AboutUs`}
          onClick={scrollToTop}
          className="cta"
          aria-label="Learn more about our creative design services"
        >
          {t("creativeDesignSection1.ctaButton")}{" "}
          <FontAwesomeIcon icon={faAngleRight} aria-hidden="true" />
        </Link>
      </div>

      {/* Right Side - Image Section */}
      <div className="design-image">
        <img
          src={designImage || "/placeholder.svg"}
          alt={t("creativeDesignSection1.imageAlt")}
          loading="lazy"
          width="600"
          height="400"
          title="Creative Design Mockup"
        />
      </div>
    </section>
  );
};

export default CreativeDesignSection1;
